import { memo, ReactNode } from 'react';
import MuiButton, { ButtonProps as MuiButtonProps } from '@mui/material/Button';
import { styled, SxProps } from '@mui/material/styles';

interface ButtonProps extends MuiButtonProps {
  disabled?: boolean;
}
interface IChildrenComponent {
  children: ReactNode;
  disabled?: boolean;
  sx?: SxProps;
}

const Button = styled(MuiButton, {
  shouldForwardProp: prop => prop !== 'disabled',
})<ButtonProps>(({ theme: { spacing, palette }, disabled }) => ({
  marginTop: spacing(1.25),
  height: spacing(6),
  textTransform: 'capitalize',
  boxShadow: 'none',
  ...(disabled && {
    backgroundColor: palette.mind.grey.disabled,
    color: palette.background.default,
    '&:hover': {
      backgroundColor: palette.mind.grey.disabled,
      boxShadow: 'none',
    },
  }),
  ...(!disabled && {
    backgroundColor: palette.mind.black.A10,
    color: palette.background.default,
    '&:hover': {
      backgroundColor: palette.mind.black.A10,
      boxShadow: 'none',
    },
  }),
}));

function LoginButton({ children, disabled, sx = {} }: IChildrenComponent): JSX.Element {
  return (
    <Button type="submit" fullWidth variant="contained" disabled={disabled} size="large" sx={sx}>
      {children}
    </Button>
  );
}

export default memo(LoginButton);
